import * as actionTypes from "../actions/actionTypes";
const initState = {
  user: null,
  userEmail: localStorage.getItem("user"),
  loadingAuth: false,
  error: null,
  currentUser: null,
  currentUserError: null,
  loggedOut: false,
  verfiyAfterSignUp: null,
};

const initAuth = (state, action) => {
  return {
    ...state,
    loadingAuth: action.loadingAuth,
    error: null,
  };
};

const successtAuth = (state, action) => {
  return {
    ...state,
    user: action.user,
    loadingAuth: action.loadingAuth,
    userEmail: action.userEmail,
    loggedOut: action.loggedOut,
    error: action.error,
    verfiyAfterSignUp: action.verfiyAfterSignUp,
  };
};

const failAuth = (state, action) => {
  return {
    ...state,
    error: action.error,
    loadingAuth: action.loadingAuth,
    verfiyAfterSignUp: action.verfiyAfterSignUp,
  };
};

const verfiyAfterSignUp = (state, action) => {
  return {
    ...state,
    verfiyAfterSignUp: action.verfiyAfterSignUp,
    loadingAuth: action.loadingAuth,
  };
};

const clearError = (state, action) => {
  return {
    ...state,
    error: action.error,
  };
};

const successLogouAuth = (state, action) => {
  return {
    ...state,
    user: action.user,
    loggedOut: action.loggedOut,
    userEmail: action.userEmail,
    error: action.error,
    verfiyAfterSignUp: action.verfiyAfterSignUp,
  };
};

const successGetLogedUserData = (state, action) => {
  return {
    ...state,
    currentUser: action.currentUser,
  };
};

const failGetLogedUserData = (state, action) => {
  return {
    ...state,
    currentUserError: action.currentUserError,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.INIT_AUTHENTICATING:
      return initAuth(state, action);
    case actionTypes.SUCCESS_AUTHENTICATING:
      return successtAuth(state, action);
    case actionTypes.FAIL_AUTHENTICATING:
      return failAuth(state, action);
    case actionTypes.CLEAR_ERROR:
      return clearError(state, action);
    case actionTypes.VERIFI_AFTER_SIGN_UP:
      return verfiyAfterSignUp(state, action);
    // LOG OUT
    case actionTypes.SUCCESS_LOGOUT_AUTHENTICATION:
      return successLogouAuth(state, action);
    // CURRENT USER :
    case actionTypes.SUCCESS_GET_CURRENT_LOGED_USER_DATA:
      return successGetLogedUserData(state, action);
    case actionTypes.FAIL_GET_CURRENT_LOGED_USER_DATA:
      return failGetLogedUserData(state, action);
    default:
      return state;
  }
};

export default Reducer;
